import { SubmenuInterface } from '@/interfaces/submenu';
import { changeRef, getTarget } from '@/utils/location';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import dynamicClass from 'clsx';
import { graphql, useStaticQuery } from 'gatsby';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../../../contexts/globalContext';
import { TabsEnum } from '../../../enums/enums';
import UseTraceItemShipping from '../../../hooks/UseTraceItemShipping';
import { normalizeWords } from '../../../utils/normalizeWords';
import FontSize from '../../atoms/font-size/fontSize';
import MenuAccordion from '../../atoms/menuAccordion/menuAccordion';
import SubmenuElement from '../../atoms/submenuElement/submenuElement';
import MenuButton from '@/components/atoms/menu-button/menuButton';
import Follows from '../follows/follows';
import './submenu.scss';

const Submenu = (props: SubmenuInterface) => {
    const { sections } = props;
    const data = useStaticQuery(graphql`
        query GET_SIDE_MENU_DATA_MOBILE {
            allContentfulTransversal(
                filter: {
                    titulo: { eq: "Transversal portal servicios personas" }
                }
            ) {
                nodes {
                    menuAccesoRapido {
                        nombre
                        redireccion
                        imagen {
                            description
                            file {
                                url
                            }
                            gatsbyImageData(
                                formats: [AUTO, WEBP]
                                placeholder: BLURRED
                            )
                        }
                        referencias {
                            ... on ContentfulCategorias {
                                nombreCategoria
                                referenciaSubcategorias {
                                    tituloPrincipal
                                    link
                                    slug
                                    nombreSubcategoria
                                    tipoCampo
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const { menuAccesoRapido } = data.allContentfulTransversal.nodes[0];

    const [showFontSize, setShowFontSize] = useState(false);
    const [activeItem, setActiveItem] = useState(0);
    const [secondFileMenu, setSecondFileMenu] = useState<any>([]);
    const [thirdFileMenu, setThirdFileMenu] = useState<any>([]);
    const [selectedMenuIndex, setSelectedMenuIndex] = useState(0);
    const [selectedSubMenuIndex, setSelectedSubMenuIndex] = useState(0);

    const { gigyaContext, selectedTab, business, userInfoContext } =
        useContext(GlobalContext);

    const classSubMenu = dynamicClass('m-submenu', {
        'm-submenu__servicios': props.show,
    });

    const onTraceItemShipping = () => {
        if (!gigyaContext?.gigyaAccount) return;
        return UseTraceItemShipping(
            gigyaContext?.gigyaAccount?.profile.firstName +
                ' ' +
                (gigyaContext.gigyaAccount.data.secondName
                    ? gigyaContext.gigyaAccount.data.secondName + ' '
                    : '') +
                gigyaContext.gigyaAccount.profile.lastName +
                (gigyaContext.gigyaAccount.data.secondLastName
                    ? ' ' + gigyaContext.gigyaAccount.data.secondLastName
                    : ''),
            gigyaContext?.gigyaAccount?.data.docNumber,
            gigyaContext?.gigyaAccount?.data.docType,
            gigyaContext?.gigyaAccount?.profile.email,
            'redirection',
            `ConoceComfama :: ${normalizeWords(sections.nombre)}`,
            userInfoContext.data?.userJwt
        );
    };

    const selectSecondFileMenu = (index) => {
        const secondContent = props.content?.[index];
        return setSecondFileMenu(secondContent);
    };

    const selectThirdFileMenu = (index) => {
        const thirdContent = secondFileMenu?.referencias[index].referencias;
        return setThirdFileMenu(thirdContent);
    };

    useEffect(() => {
        setThirdFileMenu([]);
    }, [secondFileMenu]);

    useEffect(() => {
        setSecondFileMenu(props.content?.[0]);
    }, [props.content]);
    const serviceMenu = () => {
        return props.isServiceMenu ? (
            <div>
                <ul>
                    <li
                        className={`container ${props.show ? 'show' : ''}`}
                        onClick={props.close}
                    ></li>
                    <li className={classSubMenu}>
                        <div className="m-submenu__container">
                            <div className="m-submenu__container__principal">
                                {props.content?.map(
                                    (subOption, columnIndex) => {
                                        return (
                                            columnIndex < 10 && (
                                                <div
                                                    className="m-submenu__column"
                                                    key={`subOption-${subOption.nombre}-${columnIndex}`}
                                                >
                                                    <MenuButton
                                                        name={subOption.nombre}
                                                        onClickAction={() => {
                                                            selectSecondFileMenu(
                                                                columnIndex
                                                            );
                                                            setSelectedMenuIndex(
                                                                columnIndex
                                                            );
                                                        }}
                                                        isSelected={
                                                            selectedMenuIndex ===
                                                            columnIndex
                                                        }
                                                    />
                                                </div>
                                            )
                                        );
                                    }
                                )}
                            </div>
                            {secondFileMenu && (
                                <div className="m-submenu__container__secondary">
                                    <div className="m-submenu__column-options">
                                        {secondFileMenu?.referencias
                                            ? secondFileMenu.referencias.map(
                                                  (item, index) => {
                                                      return item.referencias ? (
                                                          <div
                                                              className="m-submenu__column-options"
                                                              key={`option-subMenu-${index}`}
                                                              onClick={() => {
                                                                  selectThirdFileMenu(
                                                                      index
                                                                  );
                                                                  setSelectedSubMenuIndex(
                                                                      index
                                                                  );
                                                              }}
                                                          >
                                                              <SubmenuElement
                                                                  item={item}
                                                                  index={index}
                                                                  subOption={
                                                                      false
                                                                  }
                                                                  bold={true}
                                                                  tooltipLeft={
                                                                      false
                                                                  }
                                                                  traceLabel={`${normalizeWords(
                                                                      props.traceLabel
                                                                  )} :: ${normalizeWords(
                                                                      item.nombre
                                                                  )} ::${normalizeWords(
                                                                      item.nombre
                                                                  )}`}
                                                                  isIcon={false}
                                                                  haveChild={
                                                                      item.referencias
                                                                  }
                                                                  selectedChild={
                                                                      selectedSubMenuIndex ===
                                                                      index
                                                                  }
                                                              />
                                                          </div>
                                                      ) : (
                                                          <SubmenuElement
                                                              key={`option-subMenu-${index}`}
                                                              item={item}
                                                              index={index}
                                                              subOption={false}
                                                              bold={false}
                                                              tooltipLeft={
                                                                  false
                                                              }
                                                              traceLabel={`${normalizeWords(
                                                                  props.traceLabel
                                                              )} :: ${normalizeWords(
                                                                  item.nombre
                                                              )} :: ${normalizeWords(
                                                                  item.nombre
                                                              )}`}
                                                              isIcon={false}
                                                              isTitle={true}
                                                          />
                                                      );
                                                  }
                                              )
                                            : null}
                                    </div>
                                </div>
                            )}
                        </div>
                    </li>
                </ul>
            </div>
        ) : (
            <ul>
                <li
                    className={`container ${props.show ? 'show' : ''}`}
                    onClick={props.close}
                ></li>
                <li
                    className={`m-submenu ${
                        props.show ? 'm-submenu__conocenos' : ''
                    }`}
                >
                    {props.content?.map((section, index) => {
                        return (
                            <div
                                className="m-submenu__item"
                                key={`section-${index}-${section.nombre}`}
                            >
                                <a
                                    className="m-submenu__column-title"
                                    href={changeRef(section.redireccion)}
                                    target={getTarget(section.redireccion)}
                                    rel="noopener noreferrer"
                                    title={section.nombre}
                                    onClick={() => onTraceItemShipping()}
                                >
                                    <img
                                        src={section.imagen[0].file.url}
                                        alt={section.imagen[0].description}
                                        title={section.imagen[0].description}
                                    />
                                    {section.nombre}
                                </a>
                                <span className="m-submenu__item-description">
                                    {documentToReactComponents(
                                        JSON.parse(section.descripcion?.raw)
                                    )}
                                </span>
                            </div>
                        );
                    })}
                </li>
            </ul>
        );
    };

    const changeFontSize = (action: string, fontSize: any) => {
        if (typeof window !== 'undefined') {
            const item = document.querySelector('html') || {
                style: { fontSize },
            };
            switch (action) {
                case '+':
                    if (fontSize?.get < 120) {
                        item.style.fontSize = `${fontSize.get + 20}%`;
                        fontSize.set(fontSize.get + 20);
                    }
                    break;
                case '-':
                    if (fontSize?.get > 80) {
                        item.style.fontSize = `${fontSize.get - 20}%`;
                        fontSize.set(fontSize.get - 20);
                    }
                    break;
            }
        }
    };

    return !props.isMobile ? (
        serviceMenu()
    ) : (
        <GlobalContext.Consumer>
            {(data) => (
                <div>
                    <div
                        className={`m-submenu ${
                            props.isMenuActive ? '' : 'm-submenu--hide'
                        } `}
                    >
                        {business?.get &&
                            selectedTab?.get === TabsEnum.BUSINESS && (
                                <p className="m-submenu__column-business">
                                    {business.get.label}
                                </p>
                            )}
                        <div className="m-submenu--category__accessibility">
                            <div className="m-submenu--category__accessibility__title">
                                <div className="m-submenu--category__accessibility__title__item">
                                    <p>Accesibilidad</p>
                                </div>
                            </div>
                            <div className="m-submenu--category__accessibility__content">
                                <div className="m-submenu--category__accessibility__content__item">
                                    <i
                                        className={`icon m-header__icon ${
                                            props.isDark
                                                ? 'icon-sun'
                                                : 'icon-moon'
                                        }`}
                                        onClick={props.actionTheme}
                                    />
                                </div>
                                <div
                                    className={`m-submenu--category__accessibility__content__item ${
                                        data.fontSize?.get === 80
                                            ? '-disable'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        changeFontSize('-', data.fontSize)
                                    }
                                >
                                    <p>A-</p>
                                </div>
                                <div
                                    className={`m-submenu--category__accessibility__content__item ${
                                        data.fontSize?.get === 120
                                            ? '-disable'
                                            : ''
                                    }`}
                                    onClick={() =>
                                        changeFontSize('+', data.fontSize)
                                    }
                                >
                                    <p>A+</p>
                                </div>
                            </div>
                        </div>

                        <div className="m-submenu--category__options">
                            {props.content?.map((option, categoryIndex) => {
                                return (
                                    <MenuAccordion
                                        key={`menu-option-${categoryIndex}`}
                                        category={option}
                                        index={categoryIndex}
                                        activeItem={activeItem}
                                        setActiveItem={setActiveItem}
                                    />
                                );
                            })}
                        </div>

                        <div className="m-submenu__sidelinks">
                            <ul>
                                {menuAccesoRapido &&
                                    menuAccesoRapido
                                        .slice(0, 2)
                                        .map((item, i) => (
                                            <li key={`link${i}`}>
                                                <a
                                                    href={
                                                        item.redireccion
                                                            ? item.redireccion
                                                            : '/' + item.slug
                                                    }
                                                    target={
                                                        item.redireccion
                                                            ? '_blank'
                                                            : '_self'
                                                    }
                                                    rel="noopener noreferrer"
                                                    title={item.redireccion}
                                                >
                                                    {item.imagen && (
                                                        <img
                                                            loading="lazy"
                                                            src={
                                                                item?.imagen &&
                                                                item?.imagen[0]
                                                                    ?.file?.url
                                                            }
                                                            alt={
                                                                item?.imagen[0]
                                                                    ?.description
                                                            }
                                                            title={
                                                                item?.imagen[0]
                                                                    ?.description
                                                            }
                                                        />
                                                    )}
                                                </a>
                                                <p>{item.nombre}</p>
                                            </li>
                                        ))}
                                <li
                                    onClick={() =>
                                        setShowFontSize(!showFontSize)
                                    }
                                >
                                    <i
                                        className="icon__option icon-font-change-2"
                                        onClick={() =>
                                            setShowFontSize(!showFontSize)
                                        }
                                    />
                                    <p>Ajustar tamaño de letra</p>
                                </li>
                                <li onClick={props.actionTheme}>
                                    <i
                                        className={`icon__option ${
                                            props.isDark
                                                ? 'icon-sun gtmMenuTransTonalidadFondoBlanco'
                                                : 'icon-moon gtmMenuTransTonalidadFondoNegro'
                                        }`}
                                        onClick={props.actionTheme}
                                    />
                                    <p>
                                        {props.isDark
                                            ? 'Modo claro'
                                            : 'Modo oscuro'}
                                    </p>
                                </li>
                            </ul>
                        </div>
                        <div className="m-submenu__socialMedia">
                            <Follows
                                query={menuAccesoRapido[2].referencias[0]}
                            />
                        </div>
                        <div
                            className={`float-box ${
                                showFontSize ? 'show' : ''
                            }`}
                        >
                            <FontSize setShowFontSize={setShowFontSize} />
                        </div>
                    </div>
                </div>
            )}
        </GlobalContext.Consumer>
    );
};

export default Submenu;
